/**
 * Re-export xhr methods with browser auth data
 */
// TOOD: Use something browser fetch (or polyfill)
import { Response } from "superagent";

import { XHRClient } from "@/mk2/helpers/api";
import { GetParams, JSONData } from "@/mk2/helpers/urls";
import { CURRENT_REVISION } from "@/mk/autogenerated/gitData";
import { csrfToken } from "@/mk/common/csrfToken";
import { XHRApiAuth, makeRequest, makeRequestWithRetries } from "@/mk/xhr";

let apiAuthCsrfToken = csrfToken();

function makeClientApiAuth(): XHRApiAuth {
    // eslint-disable-next-line n/no-unsupported-features/node-builtins
    if (typeof navigator !== "undefined" && typeof document !== "undefined") {
        return {
            verifier: () => {
                // we check if the csrf-token has changed
                // since page-load. this can happen
                // for example when the user re-logins
                // in an another browser-tab
                // and then returns to this tab
                // eslint-disable-next-line n/no-unsupported-features/node-builtins
                if (typeof navigator !== "undefined" && typeof document !== "undefined") {
                    const currentCsrfToken = csrfToken();
                    if (currentCsrfToken !== apiAuthCsrfToken) {
                        const err = new Error("apiStatus verification failed");
                        (err as any).errorCode = "CSRF_CHANGED_ERROR";
                        throw err;
                    }
                }
            },
            baseUrl: "", // we could use also http://www.modrykonik.sk
            headers: [
                ["X-CSRFToken", apiAuthCsrfToken],
                ["X-Release", CURRENT_REVISION],
            ],
        };
    }
}

export let apiAuth = makeClientApiAuth();

/**
 * Wait for device to become onLine
 *
 * @param waitTime How long we should wait - defaults to: 500ms
 * @param retries How many times we should try to wait - defaults to: 20
 */
async function waitForOnLine(waitTime = 500, retries = 20) {
    for (let i = 0; i <= retries; i++) {
        if (
            // eslint-disable-next-line n/no-unsupported-features/node-builtins
            typeof navigator === "undefined" ||
            // eslint-disable-next-line n/no-unsupported-features/node-builtins
            navigator.onLine !== false
        ) {
            return;
        }
        await new Promise((resolve) => setTimeout(resolve, waitTime));
    }
    // Continue as normal - try to make a request no matter of navigator.onLine value
}

async function get(url: string, data?: GetParams): Promise<Response> {
    await waitForOnLine();
    return makeRequestWithRetries(apiAuth, "GET", url, data);
}

async function post(url: string, data?: JSONData): Promise<Response> {
    await waitForOnLine();
    return makeRequest(apiAuth, "POST", url, data);
}

function refreshApiAuth() {
    apiAuthCsrfToken = csrfToken();
    apiAuth = makeClientApiAuth();
}

export function createBrowserXhr(): XHRClient {
    return {
        get,
        post,
        refreshApiAuth,
    };
}
